import { Injectable, OnDestroy } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PlantlifeCheapWeedCardData } from '../../../../../../../../models/print-cards/plantlife-cheap-weed-card-data';
import { PlantlifeBusinessCardStackSharedLogicContentViewModel } from '../plantlife-business-card-stack-shared-logic-content-view-model';

@Injectable()
export class PlantlifeCheapWeedBusinessCardStackContentViewModel
  extends PlantlifeBusinessCardStackSharedLogicContentViewModel
  implements OnDestroy
{
  public override readonly cardData$: Observable<PlantlifeCheapWeedCardData>;

  public readonly savings$ = combineLatest([
    this.cardData$,
    this.cardStackMenu$,
    this.locationConfig$,
    this.atLeastOneGridVariantOnSale$
  ]).pipe(
    map(([cardData, menu, locationConfig, variantOnSale]) => {
      if (!variantOnSale) return 0;
      const variant = cardData?.rowVariants?.firstOrNull();
      const themeId = menu?.theme;
      const locationId = menu?.locationId;
      const companyId = menu?.companyId;
      const priceStream = locationConfig?.priceFormat;
      const originalPrice = variant?.getPriceWithoutDiscounts(themeId, locationId, companyId, priceStream);
      const salePrice = variant?.getVisiblePrice(themeId, locationId, companyId, priceStream, false);
      const savings = originalPrice - salePrice;
      return menu?.menuOptions?.hidePriceDecimal ? savings?.toFixed(0) : savings?.toFixed(2);
    })
  );

  override ngOnDestroy() {
    super.ngOnDestroy();
  }
}
